// NATIVE 


// INSTALLED 


// CUSTOM 
import { setCajaArlSelectRedux } from '../arl';
import { setCountrySelectRedux } from '../country';
import { setWorkPlaceSelectRedux } from '../work_place';
import { setBancosSelectRedux } from '../associated_bank';
import { checkingPreload, unCheckingPreload } from '../loading';
import { setTypeAccountBankSelectRedux } from '../type_account_bank';
import { setSucursalListRedux, setSucursalRedux } from './sucursalSlice';
import { setCajaCompensacionSelectRedux } from '../family_compensation_fund';
import { activeSucursalService, desactiveSucursalService, editSucursalService, 
         getSucursalDataSelectsService, getSucursalDetailService, getSucursalesByPaginateService, getSucursalesServices, 
         saveSucursalService } from '../../services/sucursal';







/**
 * Thunk action to fetch the list of "sucursales" (branches) from the service and update the Redux store.
 *
 * This function dispatches several actions to manage the loading state and update the store with the fetched data.
 *
 * @returns {Function} A thunk function that performs the asynchronous operation.
 *
 * @example
 * dispatch(getSucursalesStore());
 *
 * @async
 * @function
 */
export const getSucursalesStore = (): any => {

    return async( dispatch: any ) => {

        dispatch( checkingPreload() );

        const result = await getSucursalesServices();


        if (result.ok) {
            await dispatch( setSucursalListRedux(result.data) );
        }

        
        await dispatch( unCheckingPreload() );

        return result;
        

    }

}





/**
 * Thunk action to fetch and dispatch sucursal data selects.
 *
 * This function dispatches a preload checking action, fetches the sucursal data
 * from the service, and then dispatches various actions to update the Redux store
 * with the fetched data. Finally, it dispatches an action to uncheck the preload state.
 *
 * @returns {Function} A thunk function that performs the async operations.
 */
export const getSucursalDataSelects = (): any => {

  return async( dispatch: any ) => {
     

      await dispatch( checkingPreload() );

      const result = await  getSucursalDataSelectsService();

      if ( result.ok ) {


        await dispatch( setCountrySelectRedux(result.data.pais) );
        await dispatch( setWorkPlaceSelectRedux(result.data.sitioDeTrabajo) );

        // PAGOS
        await dispatch( setBancosSelectRedux(result.data.bancos) );
        await dispatch( setTypeAccountBankSelectRedux(result.data.tipoCuenta) );

        // SEGURIDAD SOCIAL 
        await dispatch( setCajaArlSelectRedux(result.data.arls) );
        await dispatch( setCajaArlSelectRedux(result.data.arls) );
        await dispatch( setCajaCompensacionSelectRedux(result.data.cajaCompensacion) );
        
        
        

        
      }
      
      dispatch( unCheckingPreload() );

      return result;


  }


}






/**
 * Thunk action to save a sucursal (branch) and update the Redux store.
 *
 * @param {any} sucursal - The sucursal data to be saved.
 * @param {any} setPercentajeCSucursal - A callback function to set the percentage of the sucursal creation process.
 * @returns {any} - The result of the save operation.
 *
 * This function dispatches the following actions:
 * - `checkingPreload` to indicate the start of the preload process.
 * - `unCheckingPreload` to indicate the end of the preload process.
 * - `setSucursalListRedux` to update the Redux store with the new sucursal list if the save operation is successful.
 *
 * The function constructs a `data_save` object from the provided `sucursal` data and calls the `saveSucursalService` function
 * to save the sucursal. The result of the save operation is returned.
 */
export const saveSucursal = (sucursal:any, setPercentajeCSucursal: any): any => {

    return async( dispatch: any ) => {

        dispatch( checkingPreload() );

        
        const data_save = {
              name: sucursal.sucursal_name,
              address: sucursal.sucursal_address,
              country: sucursal.country.value,
              departament: sucursal.departament.value,
              municipaly: sucursal.municipaly.value,
              workplace: sucursal.workplace.value,
              family_compensation_fund: sucursal.family_fund_compensation.value,
              landline: sucursal.landline,
              cell_phone: sucursal.cell_phone,
              arl: sucursal.arl.value,
              associated_bank: sucursal.associated_bank.value,
              type_account_bank: sucursal.type_account_bank.value,
              account_number: sucursal.account_number,
              logo: sucursal.logo_sucursal_name_saved_file
        }

        
        const result = await saveSucursalService(data_save, setPercentajeCSucursal);

        
        
       await dispatch( unCheckingPreload() );

       if ( result.ok ) {
           await dispatch( setSucursalListRedux(result.data) );
       }
       
       
        return result;
        
    }
}









/**
 * Thunk action to edit a sucursal.
 *
 * This function dispatches a preload checking action, prepares the data to be saved,
 * calls the editSucursalService with the prepared data, and finally dispatches an
 * unchecking preload action. It returns the result of the editSucursalService call.
 *
 * @param {any} sucursal - The sucursal object containing the details to be edited.
 * @param {any} setPercentajeCSucursal - A callback function to set the percentage of completion.
 * @returns {any} - The result of the editSucursalService call.
 */
export const editSucursal = (sucursal:any, setPercentajeCSucursal: any): any => {

    return async( dispatch: any ) => {

        dispatch( checkingPreload() );

        
        const data_save = {
              name: sucursal.e_sucursal_name,
              address: sucursal.e_sucursal_address,
              country: sucursal.e_country.value,
              departament: sucursal.e_departament.value,
              municipaly: sucursal.e_municipaly.value,
              workplace: sucursal.e_workplace.value,
              family_compensation_fund: sucursal.e_family_fund_compensation.value,
              landline: sucursal.e_landline,
              cell_phone: sucursal.e_cell_phone,
              arl: sucursal.e_arl.value,
              associated_bank: sucursal.e_associated_bank.value,
              type_account_bank: sucursal.e_type_account_bank.value,
              account_number: sucursal.e_account_number,
              logo: sucursal.e_logo_sucursal_name_saved_file,
              sucursalId: sucursal.sucursalId
        }

        
        const result = await editSucursalService(data_save, setPercentajeCSucursal);

        
        
       await dispatch( unCheckingPreload() );

    //    if ( result.ok ) {
    //         await dispatch( setSucursalListRedux(result.data) );
    //    }
       
       
        return result;
        
    }
}







/**
 * Thunk action to fetch and store the details of a specific "sucursal" (branch) in the Redux store.
 * 
 * @param {string} sucursalId - The ID of the "sucursal" to fetch details for.
 * @param {any} percentage - Additional parameter to be passed to the service.
 * @returns {Function} A thunk function that dispatches actions to manage the loading state and store the fetched data.
 * 
 * The thunk performs the following steps:
 * 1. Dispatches `checkingPreload` action to indicate the start of a loading process.
 * 2. Calls `getSucursalDetailService` to fetch the details of the specified "sucursal".
 * 3. Dispatches `unCheckingPreload` action to indicate the end of the loading process.
 * 4. If the fetch is successful, dispatches `setSucursalRedux` action to store the fetched data in the Redux store.
 * 5. Returns the result of the fetch operation.
 */
export const storeDetailSucursal = (sucursalId: string, percentage:any): any => {
    

    return async( dispatch: any ) => { 


        await dispatch( checkingPreload() );
        

        const result = await  getSucursalDetailService(sucursalId, percentage);
      

        dispatch( unCheckingPreload() );


        if ( result.ok ) {
            await dispatch( setSucursalRedux(result.data) );
        }


        return result;
        

    }

      
}








/**
 * Thunk action to deactivate a sucursal (branch) by its ID.
 *
 * This function dispatches a preload check, calls the service to deactivate the sucursal,
 * and then dispatches an action to update the sucursal list in the Redux store if the
 * deactivation is successful. It also handles the preload state before and after the
 * service call.
 *
 * @param {string} sucursalId - The ID of the sucursal to be deactivated.
 * @returns {Function} A thunk function that performs the asynchronous operations.
 */
export const storeDesactiveSucursal = (sucursalId: string): any => {
    

    return async( dispatch: any ) => { 

        await dispatch( checkingPreload() );
        

        const result = await  desactiveSucursalService(sucursalId);

        
        
        dispatch( unCheckingPreload() );

        if ( result.ok ) {
            await dispatch( setSucursalListRedux(result.data) );
        }

        return result;

    }

      
}






/**
 * Thunk action to store the active sucursal (branch) by its ID.
 * 
 * This function dispatches a series of actions to manage the state of the application
 * while the active sucursal is being set. It first dispatches a preload checking action,
 * then calls the `activeSucursalService` to set the active sucursal, and finally dispatches
 * an action to update the sucursal list in the Redux store if the service call is successful.
 * 
 * @param {string} sucursalId - The ID of the sucursal to be set as active.
 * @returns {Function} A thunk function that performs the async operations and dispatches actions.
 */
export const storeActiveSucursal = (sucursalId: string): any => {
    

    return async( dispatch: any ) => { 

        await dispatch( checkingPreload() );
        

        const result = await  activeSucursalService(sucursalId);

        
        
        dispatch( unCheckingPreload() );

        if ( result.ok ) {
            await dispatch( setSucursalListRedux(result.data) );
        }

        return result;

    }

      
}




export const getSucursalesByPagination = (page:number): any => {

    return async( dispatch: any ) => {


      await dispatch( checkingPreload() );
      


      const result = await  getSucursalesByPaginateService(page);


      if ( result.ok ) {
           await dispatch( setSucursalListRedux(result.data) );
      }
    
      dispatch( unCheckingPreload() );
      
      return result;
        
    }

}






